import { render, staticRenderFns } from "./PointCloudViewer.vue?vue&type=template&id=5df2baca&scoped=true"
import script from "./PointCloudViewer.vue?vue&type=script&lang=js"
export * from "./PointCloudViewer.vue?vue&type=script&lang=js"
import style0 from "./PointCloudViewer.vue?vue&type=style&index=0&id=5df2baca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df2baca",
  null
  
)

export default component.exports